const { useEffect } = require("react");

const SCAN_APP_PAGE_INFO = [
  {
    name: "Scan App Access",
    isMainToggle: true,
  },
  {
    name: "Stocks",
    isMainMenu: true,
    subMenus: [
      { name: "Send Image", options: ["WhatsApp"] },
      { name: "Proforma", options: ["View", "Create", "Share", "Download"] },
      { name: "Memo", options: ["View", "Create", "Share", "Download"] },
      { name: "Quote", options: ["View", "Create", "Share", "Download"] },
      { name: "Long Press", options: ["Create Customer Quote", "Create Stock Quote", "Set Re-Quote"] },
      { name: "Location Access", options: ["BBM", "HQ", "BBS", "IDL", "BBM Customer Stock", "BBS Customer Stock"] },
    ],
  },
  {
    name: "Settings",
    isMainMenu: true,
    subMenus: [
      { name: "Certificates", options: ["View", "Generate", "Share", "Regenerate", "Void", "Print"] },
      { name: "Melting Request", options: ["View", "Create", "Approvals", "Modify"] },
      { name: "Whatsapp logs", options: ["View"] },
      { name: "Discounts", options: ["View"] },
      { name: "Stock Details", options: ["View"] },
      { name: "Rate Master", options: ["View"] },
      { name: "Labour Master", options: ["View"] },
      { name: "Level Master", options: ["View"] },
    ],
  },
];

const CREATE_PAGE_INFO = [
  {
    name: "Concepts",
    subMenus: [
      { name: "Concepts Access", options: ["View", "Create"] },
      { name: "Concepts Actions", options: ["Start", "Archive", "Unarchive", "Hold", "Unhold"] },
    ],
  },
  {
    name: "Projects",
    subMenus: [
      { name: "Projects Access", options: ["View", "Create", "Clone", "Edit"] },
      { name: "Projects Actions", options: ["Assign", "Archive", "Unarchive", "Hold", "Unhold"] },
    ],
  },
  {
    name: "CAD",
    subMenus: [
      { name: "CAD Access", options: ["View", "Old Cad Images"] },
      { name: "CAD Actions", options: ["Reassign", "Archive", "Unarchive", "Hold", "Unhold"] },
    ],
  },
  {
    name: "Approvals",
    subMenus: [
      {
        name: "Approvals Access",
        options: ["View", "Approver"],
        infoTooltip: "Approve, Modify, STL Request, Send for Client Approval",
      },
      { name: "Approvals Actions", options: ["Bypass Client Approval", "Archive", "Unarchive"] },
    ],
  },
  {
    name: "Finalise",
    subMenus: [
      {
        name: "Finalise Access",
        options: ["View", "Finaliser"],
        infoTooltip: "Modify, Resend for Approval, Complete Finalise",
      },
      { name: "Finalise Actions", options: ["Refinalise", "Export Excel", "Generate Quote", "Hold", "Unhold"] },
    ],
  },
  {
    name: "CPD",
    subMenus: [
      { name: "CPD Access", options: ["View", "Create", "Approver", "Edit"], infoTooltip: "Approve, Reject" },
      { name: "CPD Actions", options: ["View Project", "Archive", "Unarchive"] },
    ],
  },
  {
    name: "CAM",
    subMenus: [
      { name: "CAM Access", options: ["View", "Assign"], infoTooltip: "Reassign" },
      { name: "CAM Actions", options: ["Archive", "Unarchive"] },
    ],
  },
  {
    name: "Sizing",
    subMenus: [
      { name: "Sizing Access", options: ["View", "Create", "Assign"], infoTooltip: "Reassign" },
      { name: "Sizing Actions", options: ["Archive", "Unarchive"] },
    ],
  },
  {
    name: "Modification",
    subMenus: [
      { name: "Modification Access", options: ["View", "Create", "Assign"], infoTooltip: "Reassign" },
      { name: "Modification Actions", options: ["Archive", "Unarchive"] },
    ],
  },
  {
    name: "Data Access",
    subMenus: [
      // name must match backend subMenu; label is what UI shows
      { name: "Data Access", label: "View Data", options: ["All Data", "Mine Data"] },
    ],
  },
  {
    name: "Miscellaneous Settings",
    subMenus: [
      { name: "Comments", options: ["Edit", "Delete"] },
      { name: "Item Images", options: ["View", "Create", "Edit", "Delete"] },
    ],
  },
  {
    name: "Report",
    subMenus: [
      { name: "Overview", options: ["View"] },
      { name: "Kanban", options: ["View"] },
      { name: "Lags and Alerts", options: ["View"] },
      { name: "Swot Analysis", options: ["View"] },
      { name: "Category Heatmap", options: ["View"] },
      { name: "Cad Team Performance", options: ["View"] },
      { name: "Cost Analysis", options: ["View"] },
      { name: "Speed and Efficiency", options: ["View"] },
      { name: "Time Accountability", options: ["View"] },
    ]
  },
];

const VISION_PAGE_INFO = [
  {
    name: "Catalog",
    subMenus: [
      { name: "Catalog Access", options: ["View", "Create", "Edit", "Archive", "Unarchive"] },
      { name: "Share Catalog", options: ["Share Via Links", "Share to My Binny's"] },
      { name: "Live Streaming", options: ["View", "Create", "Edit", "Cancel"] },
      { name: "Catalog Access Management", options: ["My Binny's Management", "Link Management"] },
      { name: "Reports", options: ["Catalog Reports", "Client Reports"] },
      { name: "Miscellaneous Catalog", options: ["Session History", "Renew/Revoke Access", "Reshare Link", "Edit Mobile Number of Links", "Catalog Activity"] },
    ],
  },
  {
    name: "Category",
    subMenus: [
      { name: "Category Access", options: ["View"] },
      { name: "Edit Design", options: ["Design Class", "Move Sub-Category", "Make Type", "Restrict Design"] },
    ],
  },
  {
    name: "Collection",
    subMenus: [
      { name: "Collection Access", options: ["View", "Create", "Edit", "Delete", "Edit Description", "Edit Names"] },
      {
        name: "AI Collection",
        options: [
          "All",
          "Top 30 Sold - 30 Days",
          "Top 60 Sold - 60 Days",
          "Top 90 Sold - 90 Days",
          "New 30 Sold - 30 Days",
          "New 60 Sold - 60 Days",
          "New 90 Sold - 90 Days",
          "CAD Designs",
          "Duplicate Stocks",
          "Restricted Stocks",
          "1 to 2 Years Old Stocks",
          "2 to 3 Years Old Stocks",
          "3 to 4 Years Old Stocks",
          "4 to 5 Years Old Stocks",
          "5 to 6 Years Old Stocks",
          "6 to 7 Years Old Stocks",
          "7 to 8 Years Old Stocks",
          "Binny’s Select Design",
          "New Designs",
          "New Design Out of Stock",
          "1-2 Years Design Out of Stock",
          "2-3 Years Design Out of Stock",
          "Under Ratio Design",
          "Over Ratio Design",
        ],
      },
    ],
  },
  {
    name: "Sets Access",
    subMenus: [{ name: "Sets Access", options: ["View", "Create", "Edit", "Archive", "Unarchive", "Delete "] }],
  },
  {
    name: "Stocks",
    subMenus: [
      { name: "Stocks Access", options: ["View"] },
      { name: "Location Access", options: ["BBM", "HQ", "BBS", "IDL", "BBM Customer Stock", "BBS Customer Stock"] },
      { name: "Miscellaneous Stock", options: ["Price Details", "Create Melting Request", "Stock tray Info"] },
    ],
  },
  {
    name: "Sales Setting",
    subMenus: [
      { name: "Sales By year", options: ["View"] },
      { name: "Sales By Client", options: ["View"] },
      { name: "Highest Seller Trophy", options: ["View"] },
      { name: "Best Seller Border", options: ["View"] },
    ],
  },
  {
    name: "Clients",
    subMenus: [
      { name: "Purchases", options: ["View", "Create Partial Purchase Catalog"] },
      { name: "Catalog", options: ["View"] },
      { name: "Dues & Ledger", options: ["View", "Share", "Download"] },
      { name: "Quotes & Orders", options: ["View", "Share", "Download"] },
      { name: "WIP", options: ["View"] },
      { name: "NPD Orders", options: ["View"] },
      { name: "Service Request", options: ["View", "Management"] },
      { name: "Request Visit", options: ["View"] },
    ],
  },
  {
    name: "Sync",
    subMenus: [
      { name: "Sub - Category", options: ["View", "Revert", "Sync Sub-Category"] },
      { name: "Make Type", options: ["View", "Revert", "Sync Make Type"] },
      { name: "Sets", options: ["View", "Revert", "Sync Sets"] },
      { name: "Collection", options: ["View", "Revert", "Sync Collection"] },
      { name: "Design Restriction", options: ["View", "Revert", "Sync Restrict Design"] },
      { name: "Design Class", options: ["View", "Revert", "Sync Design Class"] },
    ],
  },
  {
    name: "Settings",
    subMenus: [
      { name: "Archives", options: ["View Catalog", "View Sets", "View Quotes"] },
      { name: "Design Import", options: ["View", "Export Design"] },
      { name: "Design Update", options: ["View", "Export Design"] },
      { name: "Event Type", options: ["View", "Add", "Edit", "Delete"] },
      { name: "Limits", options: ["Clients", "User"] },
      { name: "Labour Rights", options: ["View", "Edit"] },
      { name: "Melting Request", options: ["View", "Approval Management", "Finalisation"] },
      { name: "Main Activity", options: ["View"] },
      { name: "Missing Images", options: ["View", "Upload Image"] },
      { name: "Quotes", options: ["View", "Create", "Archive", "Share", "Download"] },
      { name: "Product USP and Gallery", options: ["View", "Add", "Delete", "Edit", "Multiple Mapping"] },
      { name: "Restricted Designs", options: ["View", "Unrestict"] },
      { name: "Rights", options: ["View", "Edit"] },
      { name: "Roles", options: ["View", "Create", "Edit", "Delete"] },
      { name: "Rate Master Rights", options: ["View", "Edit"] },
      { name: "Service Requests", options: ["View", "Management","Client Name","Status"] },
      { name: "Stock Tray", options: ["View", "Add", "Edit", "Delete"] },
      { name: "User", options: ["View", "Create", "Edit", "Delete"] },
      { name: "Update Images", options: ["View"] },
    ],
  },
  {
    name: "Implicit Settings",
    subMenus: [
      { name: "Design Date", options: ["View"] },
      { name: "Devices", options: ["Web Accessibility", "Mobile Accessibility"] },
      { name: "Profile", options: ["View", "Edit"] },
      { name: "Screenshots", options: ["View"] },
      { name: "Watermark", options: ["View"] },
      { name: "Waba Rights", options: ["View", "Edit"] },
      { name: "Quick Access", options: ["Create Project", "Create Modification", "Create Customer Quote", "Create Stock Quote", "Set Re-Stock Quote", "Hide Design"] },
    ],
  },
];

const MYBINNYS_APP_PAGE_INFO = [
  { name: "Client Management", options: ["View", "Add", "Delete", "Purchase Control"] },
  { name: "User Management", options: ["Add", "Delete", "User Control"] },
  { name: "Report Management", options: ["View", "Edit"] },
];

const TRACK_APP_PAGE_INFO = [
  { name: "Dues", options: ["Customers", "Suppliers", "Share", "Download"] },
  { name: "Ledger", options: ["Customers", "Suppliers", "Share", "Download"] },
  { name: "WIP", options: ["View"] },
  { name: "Order", options: ["Pending", "WIP", "Completed", "Cancelled"] },
  { name: "Quote", options: ["Pending", "Cancelled", "Completed"] },
  { name: "Bag Out", options: ["View"] },
  { name: "Location Access", options: ["HQ", "BBM", "BBS"] },
];

const SELECT_PAGE_INFO = [
  { name: "Binny's Select Access", options: ["View"] },
  { name: "Quotes", options: ["All", "Own", "None"] },
  { name: "Share Access", options: ["Share", "Download"] },
  { name: "Is Stock Manager", options: ["View"] },
  { name: "Role Switch", options: ["View"] },
];

const NEXUS_WEB_PAGE_INFO = [
  {
    name: "Nexus Web Access",
    isMainToggle: true,
  },
  // Groups are UI-only; rights stored flat by sub name (same as Scan App) → sub names must stay unique
  {
    name: "Sales",
    isMainMenu: true,
    subMenus: [
      { name: "Day", options: ["View"] },
      { name: "Weekly", options: ["View"] },
      { name: "Monthly", options: ["View"] },
      { name: "Quarterly", options: ["View"] },
      { name: "Financial Year", options: ["View"] },
      { name: "Categories", options: ["View"] },
      { name: "Geo Distribution", options: ["View"] },
      { name: "Clients", options: ["View"] },
      { name: "Exhibition", options: ["View"] },
      { name: "Sales Analytics", options: ["View"] },
      { name: "Material Sales", options: ["View"] },
    ],
  },
  {
    name: "Production",
    isMainMenu: true,
    subMenus: [
      { name: "WIP", options: ["View"] },
      { name: "Process Loss", options: ["View"] },
      { name: "Department Output", options: ["View"] },
      { name: "Refinery Efficiency", options: ["View"] },
      { name: "Refining", options: ["View"] },
      { name: "Worker Wise", options: ["View"] },
      { name: "FG", options: ["View"] },
      { name: "Bags On Hold", options: ["View"] },
      { name: "Memo Out", options: ["View"] },
      { name: "Cost Per Gram", options: ["View"] },
      { name: "TAT Promise Master", options: ["View"] },
    ],
  },
  {
    name: "Inventory",
    isMainMenu: true,
    subMenus: [
      { name: "Material Purchase", options: ["View"] },
      { name: "Materials", options: ["View"] },
    ],
  },
  {
    name: "Finance",
    isMainMenu: true,
    subMenus: [
      { name: "Cash Command", options: ["View"] },
      { name: "Salary Dept", options: ["View"] },
      { name: "Expenses", options: ["View"] },
    ],
  },
];

const FAB_PAGE_INFO = [
  { name: "Fab Web Access", isMainToggle: true },
  { name: "Create Task", options: ["Create", "Assign"] },
  { name: "Dashboard", options: ["View"] },
  { name: "Live Map", options: ["View"] },
  { name: "History", options: ["View"] },
  { name: "Requests", options: ["View", "Select Agent", "Modify"] },
  { name: "Expenses", options: ["View"] },
  { name: "Report", options: ["View"] },
  { name: "Setting", options: ["View"] },
  { name: "Users", options: ["View", "Add", "Edit", "Remove"] },
  { name: "Customers", options: ["View", "Add", "Edit", "Remove"] },
];

const BRECO_PAGE_INFO = [
  { name: "Breco Web Access", isMainToggle: true }, // Groups are UI-only; rights stored flat by sub name (same as Nexus) → sub names must stay unique
  {
    name: "Workspace",
    isMainMenu: true,
    subMenus: [
      { name: "Approval Queue", options: ["View"] },
      { name: "Settlement Pending", options: ["View"] },
      { name: "Approved", options: ["View"] },
      { name: "Rejected", options: ["View"] },
      { name: "Unmatched", options: ["View"] },
    ],
  },
  {
    name: "Reports",
    isMainMenu: true,
    subMenus: [
      { name: "Daily Reco", options: ["View"] },
      { name: "Due Report", options: ["View"] },
      { name: "Rate-Cut Book", options: ["View"] },
      { name: "Recent Settlements", options: ["View"] },
      { name: "Audit Log", options: ["View"] },
      { name: "Auto-Learn Memory", options: ["View"] },
    ],
  },
];

const AIRA_APP_PAGE_INFO = [
  { name: "Aira App Access", isMainToggle: true },
  // { name: "Home", options: ["View"] },
  { name: "Client", options: ["View"] },
  { name: "Promise", options: ["View"] },
  { name: "Dispute", options: ["View"] },
  { name: "Approval", options: ["View", "Edit", "Approve"] },
  { name: "Unfix", options: ["View"] },
  { name: "Brain", options: ["View"] },
  { name: "Daily report", options: ["View"] },
  { name: "Chat", options: ["View", "Chat"] },
  { name: "Cliq", options: ["Chat"] },
  { name: "Logs & History", options: ["Approval","Doubletick","Cliq Logs"] },
];

const EXPO_PAGE_INFO = [
   { name: "Expense tracker Web Access", isMainToggle: true },
    {
      name: "Details",
      isMainToggle: false,
      options: ["View"]
    },
    {
      name: "Comparison",
      isMainToggle: false,
      options: ["View"]
    },
    {
      name: 'Forex Cash',
      isMainToggle: false,
      options: ["Allocate Cash"]
    },
    {
      name: "Settings",
      isMainToggle: false,
      options: ["View"]
    },
    {
      name: "Exhibition",
      isMainToggle: false,
      options: ["Edit", "Create", "Download", "Delete"]
    }
];

const CRECO_PAGE_INFO = [
  { name: "Creco Web Access", isMainToggle: true },
   {
    name: "Accounts",
    subMenus: [
      {
        name: "Account Access",
        options: ["View", "Edit", "Download","Add Card"]
      },
      { name: "Invoice", options: ["View", "Edit", "Delete", "Download", "Add"] },
      { name: "Statement", options: ["View"] },
    ]
  },
  {
    name: "Dashboard",
    isMainToggle: false,
    options: ["View"]
  },
  {
    name: "Card Intelligence",
    isMainToggle: false,
    options: ["View"]
  },
  {
    name: "Settings",
    subMenus: [
      {
        name: 'Setting Access',
        options: ["View"]
      },
      { name: "By Card", options: ["View", "Add"] },
      { name: "By Category", options: ["View", "Add"] },
      { name: "By Person", options: ["View", "Add"] },
    ]
  },
];

const TECHIE_PAGE_INFO = [
  {
    name: "Dashboard",
    isMainToggle: false,
    options: ["View"]
  },
  {
    name: "Updates",
    isMainToggle: false,
    options: ["View"]
  },
  {
    name: "Releases",
    isMainToggle: false,
    options: ["View"]
  },
  {
    name: "Pod Perf",
    isMainToggle: false,
    options: ["View"]
  },
  {
    name: "Reviews",
    isMainToggle: false,
    options: ["View", "Start Testing", "Mark As Tested", "Reject"]
  }
];

const ClientMaster_PAGE_INFO = [
  { name: "Client Master App Access", isMainToggle: true },
  {
    name: "Approve",
    isMainToggle: false,
    options: ["Add", "Update"]
  },
  {
    name: "Request",
    isMainToggle: false,
    options: ["Add", "Update"]
  }
];



const PURCHIE_PAGE_INFO = [
  { name: "Purchase Orders", options: ["View", "New Purchase Order"] },
  { name: "Approvals", options: ["Waiting For You", "Already Decided", "Date Filter", "Year Change"] },
  { name: "Goods Received", options: ["Verify Goods", "Reports", "Mismatch Report", "Date Filter", "Year Change"] },
  { name: "Bills & Payments", options: ["View"] },
  { name: "Vendors", options: ["All Vendors", "Vendor Master", "Date Filter", "Year Change", "Rate Change", "Approve Rate", "Reject Rate", "Download Rate Sheet"] },
  { name: "Items", options: ["View", "Date Filter", "Year Change", "Bulk Upload", "Create Item Via Gati", "Create Item Via Purchie"] },
  { name: "Stock", options: ["View", "Date Filter", "Year Change", "Send Email"] },
  { name: "Upload Images", options: ["View", "Upload"] },
  { name: "Reports", options: ["Transaction Report", "Date Filter", "Year Change"] },
  { name: "Settings", options: ["Items Rate", "Download Excel"] },
];

const DEFAULT_FAB_RIGHT = {
  menu: "Fab",
  add: false, edit: false, view: false, archive: false, isAllSelected: false,
  subRights: [
    { subMenu: "Fab Web Access", enabled: false },
    { subMenu: "Create Task", enabled: false, permissions: [{ key: "create", label: "Create", allowed: false }, { key: "assign", label: "Assign", allowed: false }] },
    { subMenu: "Dashboard", enabled: false, permissions: [{ key: "view", label: "View", allowed: false }] },
    { subMenu: "Live Map", enabled: false, permissions: [{ key: "view", label: "View", allowed: false }] },
    { subMenu: "History", enabled: false, permissions: [{ key: "view", label: "View", allowed: false }] },
    { subMenu: "Requests", enabled: false, permissions: [{ key: "view", label: "View", allowed: false }, { key: "select_agent", label: "Select Agent", allowed: false }, { key: "modify", label: "Modify", allowed: false }] },
    { subMenu: "Expenses", enabled: false, permissions: [{ key: "view", label: "View", allowed: false }] },
    { subMenu: "Report", enabled: false, permissions: [{ key: "view", label: "View", allowed: false }] },
    { subMenu: "Setting", enabled: false, permissions: [{ key: "view", label: "View", allowed: false }] },
    { subMenu: "Users", enabled: false, permissions: [{ key: "view", label: "View", allowed: false }, { key: "add", label: "Add", allowed: false }, { key: "edit", label: "Edit", allowed: false }, { key: "remove", label: "Remove", allowed: false }] },
    { subMenu: "Customers", enabled: false, permissions: [{ key: "view", label: "View", allowed: false }, { key: "add", label: "Add", allowed: false }, { key: "edit", label: "Edit", allowed: false }, { key: "remove", label: "Remove", allowed: false }] },
  ],
};

const DEFAULT_BRECO_RIGHT = {
  menu: "Breco",
  add: false, edit: false, view: false, archive: false, isAllSelected: false,
  allowedGroupIds: [],
  subRights: [
    { subMenu: "Breco Web Access", enabled: false },
    { subMenu: "Due Report", enabled: false, permissions: [{ key: "view", label: "View", allowed: false }, { key: "groups_set", label: "Group Set", allowed: false }] },
    ...[
      "Approval Queue", "Settlement Pending", "Approved", "Rejected", "Unmatched",
      "Daily Reco", "Rate-Cut Book", "Recent Settlements", "Audit Log", "Auto-Learn Memory",
    ].map((subMenu) => ({ subMenu, enabled: false, permissions: [{ key: "view", label: "View", allowed: false }] })),
  ],
};

const DEFAULT_AIRA_RIGHT = {
  menu: "Aira",
  add: false, edit: false, view: false, archive: false, isAllSelected: false,
  subRights: [
    { subMenu: "Aira App Access", enabled: false },
    // { subMenu: "Home", enabled: false, permissions: [{ key: "view", label: "View", allowed: false }] },
    { subMenu: "Client", enabled: false, permissions: [{ key: "view", label: "View", allowed: false }] },
    { subMenu: "Promise", enabled: false, permissions: [{ key: "view", label: "View", allowed: false }] },
    { subMenu: "Dispute", enabled: false, permissions: [{ key: "view", label: "View", allowed: false }] },
    { subMenu: "Approval", enabled: false, permissions: [{ key: "view", label: "View", allowed: false }, { key: "edit", label: "Edit", allowed: false }, { key: "approve", label: "Approve", allowed: false }] },
    { subMenu: "Unfix", enabled: false, permissions: [{ key: "view", label: "View", allowed: false }] },
    { subMenu: "Brain", enabled: false, permissions: [{ key: "view", label: "View", allowed: false }] },
    { subMenu: "Daily report", enabled: false, permissions: [{ key: "view", label: "View", allowed: false }] },
    { subMenu: "Chat", enabled: false, permissions: [{ key: "view", label: "View", allowed: false }, { key: "chat", label: "Chat", allowed: false }] },
    { subMenu: "Cliq", enabled: false, permissions: [{ key: "chat", label: "Chat", allowed: false }] },
    {
      subMenu: "Logs & History", enabled: false, permissions: [
        { key: "approval_history", label: "Approval", allowed: false },
        { key: "double_tick", label: "Doubletick", allowed: false },
        { key: "cliq_logs", label: "Cliq Logs", allowed: false },
      ]
    },
  ],
};

const DEFAULT_EXPO_RIGHT = {
  menu: "Expo",
  add: false, edit: false, view: false, archive: false, isAllSelected: false,
  subRights: [
    {
      subMenu: "Expense tracker Web Access",
      enabled: false
    },
    {
      subMenu: "Details",
      enabled: false,
      permissions: [
        { key: "view", label: "View", allowed: false },
      ]
    },
    {
      subMenu: "Comparison",
      enabled: false,
      permissions: [
        { key: "view", label: "View", allowed: false },
      ]
    },
    {
      subMenu: 'Forex Cash',
      enabled: false,
      permissions: [
        { key: "allocate_cash", label: "Allocate Cash", allowed: false },
      ]
    },
    {
      subMenu: "Settings",
      enabled: false,
      permissions: [
        { key: "view", label: "View", allowed: false },
      ]
    },
    {
      subMenu: "Exhibition",
      enabled: false,
      permissions: [
        { key: "edit", label: "Edit", allowed: false },
        { key: "create", label: "Create", allowed: false },
        { key: "download", label: "Download", allowed: false },
        { key: "delete", label: "Delete", allowed: false },
      ]
    }
  ]
};

const DEFAULT_CRECO_RIGHT = {
    menu: "Creco",
    add: false,
    edit: false,
    view: false,
    archive: false,
    isAllSelected: false,
    subRights: [
        {
            subMenu: "Creco Web Access",
            enabled: false
        },
        {
            subMenu: "Account Access",
            enabled: false,
            permissions: [
                { key: "view", label: "View", allowed: false },
                { key: "edit", label: "Edit", allowed: false },
                { key: "download", label: "Download", allowed: false },
                { key: "add_card", label: "Add Card", allowed: false }
            ]
        },
        {
            subMenu: "Dashboard",
            enabled: false,
            permissions: [
                { key: "view", label: "View", allowed: false },
            ]
        },
        {
            subMenu: "Card Intelligence",
            enabled: false,
            permissions: [
                { key: "view", label: "View", allowed: false },
            ]
        },
        {
            subMenu: "Setting",
            enabled: false,
            permissions: [
                { key: "view", label: "View", allowed: false },
            ]
        },
        {
            subMenu: "Invoice",
            enabled: false,
            permissions: [
                { key: "view", label: "View", allowed: false },
                { key: "edit", label: "Edit", allowed: false },
                { key: "delete", label: "Delete", allowed: false },
                { key: "download", label: "Download", allowed: false },
                { key: "add", label: "Add", allowed: false },
            ]
        },
        {
            subMenu: "Statement",
            enabled: false,
            permissions: [
                { key: "view", label: "View", allowed: false },
            ]
        },
        {
            subMenu: "By Card",
            enabled: false,
            permissions: [
                { key: "view", label: "View", allowed: false },
                { key: "add", label: "Add", allowed: false },
            ]
        },
        {
            subMenu: "By Category",
            enabled: false,
            permissions: [
                { key: "view", label: "View", allowed: false },
                { key: "add", label: "Add", allowed: false },
            ]
        },
         {
            subMenu: "By Person",
            enabled: false,
            permissions: [
                { key: "view", label: "View", allowed: false },
                { key: "add", label: "Add", allowed: false },
            ]
        },
    ],
};

const DEFAULT_Client_Master_RIGHT = {
    menu: "Client Master",
    add: false,
    edit: false,
    view: false,
    archive: false,
    isAllSelected: false,
    subRights: [
        {
            subMenu: "Client Master App Access",
            enabled: false
        },
        {
            subMenu: "Approve",
            enabled: false,
            permissions: [
                { key: "add", label: "Add", allowed: false },
                { key: "update", label: "Update", allowed: false },
            ]
        },
        {
            subMenu: "Request",
            enabled: false,
            permissions: [
                { key: "add", label: "Add", allowed: false },
                { key: "update", label: "Update", allowed: false },
            ]
        }
    ],
};

const DEFAULT_TECHIE_RIGHT = {
    menu: "Techie",
    add: false,
    edit: false,
    view: false,
    archive: false,
    isAllSelected: false,
    subRights: [
        {
            subMenu: "Dashboard",
            enabled: false,
            permissions: [
                { key: "view", label: "View", allowed: false },
            ]
        },
        {
            subMenu: "Updates",
            enabled: false,
            permissions: [
                { key: "view", label: "View", allowed: false },
            ]
        },
        {
            subMenu: "Releases",
            enabled: false,
            permissions: [
                { key: "view", label: "View", allowed: false },
            ]
        },
        {
            subMenu: "Pod Perf",
            enabled: false,
            permissions: [
                { key: "view", label: "View", allowed: false },
            ]
        },
        {
            subMenu: "Reviews",
            enabled: false,
            permissions: [
                { key: "view", label: "View", allowed: false },
                { key: "start_testing", label: "Start Testing", allowed: false },
                { key: "mark_as_tested", label: "Mark As Tested", allowed: false },
                { key: "reject", label: "Reject", allowed: false }
            ]
        },
    ],
};

const DEFAULT_PURCHIE_RIGHT = {
    menu: "Purchie",
    add: false,
    edit: false,
    view: false,
    archive: false,
    isAllSelected: false,
    subRights: [
        {
            subMenu: "Purchase Orders",
            enabled: false,
            permissions: [
                { key: "view", label: "View", allowed: false },
                { key: "create", label: "New Purchase Order", allowed: false },
            ]
        },
        {
            subMenu: "Approvals",
            enabled: false,
            permissions: [
                { key: "waiting_for_you", label: "Waiting For You", allowed: false },
                { key: "already_decided", label: "Already Decided", allowed: false },
                { key: "date_filter", label: "Date Filter", allowed: false },
                { key: "year_change", label: "Year Change", allowed: false },
            ]
        },
        {
            subMenu: "Goods Received",
            enabled: false,
            permissions: [
                { key: "verify_goods", label: "Verify Goods", allowed: false },
                { key: "reports", label: "Reports", allowed: false },
                { key: "mismatch_report", label: "Mismatch Report", allowed: false },
                { key: "date_filter", label: "Date Filter", allowed: false },
                { key: "year_change", label: "Year Change", allowed: false },
            ]
        },
        {
            subMenu: "Bills & Payments",
            enabled: false,
            permissions: [
                { key: "view", label: "View", allowed: false },
            ]
        },
        {
            subMenu: "Vendors",
            enabled: false,
            permissions: [
                { key: "all_vendors", label: "All Vendors", allowed: false },
                { key: "vendor_master", label: "Vendor Master", allowed: false },
                { key: "date_filter", label: "Date Filter", allowed: false },
                { key: "year_change", label: "Year Change", allowed: false },
                { key: "rate_change", label: "Rate Change", allowed: false },
                { key: "approve_rate", label: "Approve Rate", allowed: false },
                { key: "reject_rate", label: "Reject Rate", allowed: false },
                { key: "download_rate_sheet", label: "Download Rate Sheet", allowed: false },
            ]
        },
        {
            subMenu: "Items",
            enabled: false,
            permissions: [
                { key: "view", label: "View", allowed: false },
                { key: "date_filter", label: "Date Filter", allowed: false },
                { key: "year_change", label: "Year Change", allowed: false },
                { key: "bulk_upload", label: "Bulk Upload", allowed: false },
                { key: "create_via_gati", label: "Create Item Via Gati", allowed: false },
                { key: "create_via_purchie", label: "Create Item Via Purchie", allowed: false },
            ]
        },
        {
            subMenu: "Stock",
            enabled: false,
            permissions: [
                { key: "view", label: "View", allowed: false },
                { key: "date_filter", label: "Date Filter", allowed: false },
                { key: "year_change", label: "Year Change", allowed: false },
                { key: "send_email", label: "Send Email", allowed: false },
            ]
        },
        {
            subMenu: "Upload Images",
            enabled: false,
            permissions: [
                { key: "view", label: "View", allowed: false },
                { key: "upload", label: "Upload", allowed: false },
            ]
        },
        {
            subMenu: "Reports",
            enabled: false,
            permissions: [
                { key: "transaction_report", label: "Transaction Report", allowed: false },
                { key: "date_filter", label: "Date Filter", allowed: false },
                { key: "year_change", label: "Year Change", allowed: false },
            ]
        },
        {
            subMenu: "Settings",
            enabled: false,
            permissions: [
                { key: "items_rate", label: "Items Rate", allowed: false },
                { key: "download_excel", label: "Download Excel", allowed: false },
            ]
        }
    ],
};

const DEFAULT_RIGHTS_MAP = {
  Fab: DEFAULT_FAB_RIGHT,
  Breco: DEFAULT_BRECO_RIGHT,
  Aira: DEFAULT_AIRA_RIGHT,
  Expo: DEFAULT_EXPO_RIGHT,
  Creco: DEFAULT_CRECO_RIGHT,
  Techie: DEFAULT_TECHIE_RIGHT,
  "Client Master": DEFAULT_Client_Master_RIGHT,
  Purchie: DEFAULT_PURCHIE_RIGHT,
};

const TOGGLE_TAB_CONFIG = {
  "Scan App": { menuName: "Scan", toggleKey: "Scan App Access" },
  "Nexus": { menuName: "Nexus", toggleKey: "Nexus Web Access" },
  "Fab": { menuName: "Fab", toggleKey: "Fab Web Access" },
  "Breco": { menuName: "Breco", toggleKey: "Breco Web Access" },
  "Aira": { menuName: "Aira", toggleKey: "Aira App Access" },
  "Expo": { menuName: "Expo", toggleKey: "Expense tracker Web Access" },
  "Creco": { menuName: "Creco", toggleKey: "Creco Web Access" },
  "Client Master": { menuName: "Client Master", toggleKey: "Client Master App Access" },
};

const TAB_TO_MENU_MAP = {
  Vision: ["Vision Web"],
  "Track App": ["Track App"],
  "My Binny's": ["My Binny's"],
  Create: ["Create"],
  Select: ["Select"],
  "Scan App": ["Scan"],
  "Nexus": ["Nexus"],
  Fab: ["Fab"],
  Breco: ["Breco"],
  Aira: ["Aira"],
  Expo: ["Expo"],
  Creco: ["Creco"],
  Techie: ["Techie"],
  "Client Master": ["Client Master"],
  Purchie: ["Purchie"],
};

const TABS = ["Vision", "Select", "My Binny's", "Scan App", "Create", "Track App", "Nexus", "Fab", "Breco", "Aira", "Expo", "Creco", "Techie", "Client Master", "Purchie"];


const sectionObject = {
  Vision: VISION_PAGE_INFO,
  Create: CREATE_PAGE_INFO,
  "My Binny's": MYBINNYS_APP_PAGE_INFO,
  Select: SELECT_PAGE_INFO,
  "Scan App": SCAN_APP_PAGE_INFO,
  "Track App": TRACK_APP_PAGE_INFO,
  "Nexus": NEXUS_WEB_PAGE_INFO,
  Fab: FAB_PAGE_INFO,
  Breco: BRECO_PAGE_INFO,
  Aira: AIRA_APP_PAGE_INFO,
  Expo: EXPO_PAGE_INFO,
  Creco: CRECO_PAGE_INFO,
  Techie: TECHIE_PAGE_INFO,
  "Client Master": ClientMaster_PAGE_INFO,
  Purchie: PURCHIE_PAGE_INFO,
};

const getInfoTooltipText = (name) => {
  switch (name) {
    case "Approvals":
      return "Approve, Modify, STL Request, Send For Client Approval";

    case "Finalise":
      return "Modify, Resend for Approval, Complete Finalise";

    case "CPD":
      return "Approve, Reject";

    case "CAM":
    case "Sizing":
    case "Modification":
      return "Reassign";

    default:
      return "";
  }
};

const tabNames = {
  "Vision": "Vision",
  "Select": "Select",
  "My Binny's": "My Binny's",
  "Scan App": "Scan",
  "Create": "Create",
  "Track App": "Track",
  "Nexus": "Nexus",
  "Fab": "Fab",
  "Breco": "Breco",
  "Aira": "Aira",
  "Expo": "Expo",
  "Creco": "Creco",
  "Techie": "Techie",
  "Client Master": "Client Master",
  "Purchie": "Purchie",
}

const collapsedButtons = ["Vision", "Create", "Scan App", "Nexus", "Breco"]

const VALIDATION_CONFIG = {
  Vision: {
    hasView: (key, pageInfo) => {
      return pageInfo.some(main =>
        main.subMenus?.some(sub =>
          `${main.name}_${sub.name}` === key && sub.options?.includes("View")
        )
      );
    },
    onInvalid: (selections, checked, key) => {
      selections[key] = [];
      checked[key] = false;
    },
  },

  "My Binny's": {
    hasView: (key, pageInfo) => {
      return pageInfo.some(item => item.name === key && item.options?.includes("View"));
    },
    onInvalid: (selections, checked, key) => {
      delete selections[key];
      checked[key] = false;
    },
    customValidation: (selections, checked) => {
      let changed = false;
      const hasClientView = selections["Client Management"]?.includes("View");

      if (!hasClientView) {
        ["User Management", "Report Management"].forEach(key => {
          if (checked[key]) {
            checked[key] = false;
            changed = true;
          }
          if (selections[key]?.length) {
            delete selections[key];
            changed = true;
          }
        });
      }
      return changed;
    },
  },

  "Scan App": {
    hasView: (key, pageInfo) => {
      for (const item of pageInfo) {
        if (item.name === key && item.options?.includes("View")) {
          return true;
        }
        if (item.subMenus && Array.isArray(item.subMenus)) {
          for (const subItem of item.subMenus) {
            if (subItem.name === key && subItem.options?.includes("View")) {
              return true;
            }
          }
        }
      }
      return false;
    },
    onInvalid: (selections, checked, key) => {
      delete selections[key];
      checked[key] = false;
    },
  },

  Create: {
    hasView: (key, pageInfo) => {
      return pageInfo.some(main => {
        if (key === main.name && main.options?.includes("View")) return true;
        return main.subMenus?.some(sub =>
          `${main.name}_${sub.name}` === key && sub.options?.includes("View")
        );
      });
    },
    onInvalid: (selections, checked, key) => {
      delete selections[key];
      checked[key] = false;
    },
  },

  Nexus: {
    hasView: (key, pageInfo) => {
      for (const item of pageInfo) {
        if (item.name === key && item.options?.includes("View")) {
          return true;
        }
        if (item.subMenus && Array.isArray(item.subMenus)) {
          for (const subItem of item.subMenus) {
            if (subItem.name === key && subItem.options?.includes("View")) {
              return true;
            }
          }
        }
      }
      return false;
    },
    onInvalid: (selections, checked, key) => {
      delete selections[key];
      checked[key] = false;
    },
  },

  "Client Master": {
    hasView: (key, pageInfo) => {
      for (const item of pageInfo) {
        if (item.name === key && item.options?.includes("View")) {
          return true;
        }
        if (item.subMenus && Array.isArray(item.subMenus)) {
          for (const subItem of item.subMenus) {
            if (subItem.name === key && subItem.options?.includes("View")) {
              return true;
            }
          }
        }
      }
      return false;
    },
    onInvalid: (selections, checked, key) => {
      delete selections[key];
      checked[key] = false;
    },
  },
};

const useRightsValidation = (activeTab, permissionSelection, checkedState, setPermissionSelection, setCheckedState) => {
  useEffect(() => {
    const config = VALIDATION_CONFIG[activeTab];
    if (!config) return;

    const pageInfo = sectionObject[activeTab];
    let hasChanges = false;
    const newSelections = { ...permissionSelection };
    const newChecked = { ...checkedState };

    Object.keys(newChecked).forEach(key => {
      const selectedOptions = permissionSelection[key] || [];
      if (config.hasView(key, pageInfo) && !selectedOptions.includes("View") && selectedOptions.length > 0) {
        config.onInvalid(newSelections, newChecked, key);
        hasChanges = true;
      }
    });

    if (config.customValidation) {
      hasChanges = config.customValidation(newSelections, newChecked) || hasChanges;
    }

    if (hasChanges) {
      setPermissionSelection(newSelections);
      setCheckedState(newChecked);
    }
  }, [permissionSelection, checkedState, activeTab]);
};

module.exports = {
  SCAN_APP_PAGE_INFO,
  CREATE_PAGE_INFO,
  VISION_PAGE_INFO,
  MYBINNYS_APP_PAGE_INFO,
  TRACK_APP_PAGE_INFO,
  SELECT_PAGE_INFO,
  NEXUS_WEB_PAGE_INFO,
  FAB_PAGE_INFO,
  BRECO_PAGE_INFO,
  AIRA_APP_PAGE_INFO,
  TOGGLE_TAB_CONFIG,
  DEFAULT_RIGHTS_MAP,
  TAB_TO_MENU_MAP,
  EXPO_PAGE_INFO,
  CRECO_PAGE_INFO,
  TECHIE_PAGE_INFO,
  ClientMaster_PAGE_INFO,
  PURCHIE_PAGE_INFO,
  TABS,
  sectionObject,
  getInfoTooltipText,
  tabNames,
  collapsedButtons,
  useRightsValidation,
}